import React, {useState} from 'react'
import Hero from '../components/Hero'
import PillButton from '../components/PillButton'
export default function Home() {
    return(
        <Hero>
        </Hero>
    )
}